const body =
  'Сегодня вдохновляющая цитата решила взять выходной, но твоя трезвость работает круглосуточно. Это твоя сила.';

const source = 'Разработчики приложения';

export default Object.freeze({body, source});
